import { gsap } from "./gsap.js";
import { defineElement } from "./gw.js";
function getDefaultExportFromCjs(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default")
    ? x["default"]
    : x;
}
var hoverintent$1;
var hasRequiredHoverintent;
function requireHoverintent() {
  if (hasRequiredHoverintent) return hoverintent$1;
  hasRequiredHoverintent = 1;
  hoverintent$1 = function (el, onOver, onOut) {
    var x, y, pX, pY;
    var mouseOver = false;
    var focused = false;
    var h = {},
      state = 0,
      timer = 0;
    var options = {
      sensitivity: 7,
      interval: 100,
      timeout: 0,
      handleFocus: false,
    };
    function delay(el2, e) {
      if (timer) timer = clearTimeout(timer);
      state = 0;
      return focused ? void 0 : onOut.call(el2, e);
    }
    function tracker(e) {
      x = e.clientX;
      y = e.clientY;
    }
    function compare(el2, e) {
      if (timer) timer = clearTimeout(timer);
      if (Math.abs(pX - x) + Math.abs(pY - y) < options.sensitivity) {
        state = 1;
        return focused ? void 0 : onOver.call(el2, e);
      } else {
        pX = x;
        pY = y;
        timer = setTimeout(function () {
          compare(el2, e);
        }, options.interval);
      }
    }
    h.options = function (opt) {
      var focusOptionChanged = opt.handleFocus !== options.handleFocus;
      options = Object.assign({}, options, opt);
      if (focusOptionChanged) {
        options.handleFocus ? addFocus() : removeFocus();
      }
      return h;
    };
    function dispatchOver(e) {
      mouseOver = true;
      if (timer) timer = clearTimeout(timer);
      el.removeEventListener("mousemove", tracker, false);
      if (state !== 1) {
        pX = e.clientX;
        pY = e.clientY;
        el.addEventListener("mousemove", tracker, false);
        timer = setTimeout(function () {
          compare(el, e);
        }, options.interval);
      }
      return this;
    }
    function dispatchOut(e) {
      mouseOver = false;
      if (timer) timer = clearTimeout(timer);
      el.removeEventListener("mousemove", tracker, false);
      if (state === 1) {
        timer = setTimeout(function () {
          delay(el, e);
        }, options.timeout);
      }
      return this;
    }
    function dispatchFocus(e) {
      if (!mouseOver) {
        focused = true;
        onOver.call(el, e);
      }
    }
    function dispatchBlur(e) {
      if (!mouseOver && focused) {
        focused = false;
        onOut.call(el, e);
      }
    }
    function addFocus() {
      el.addEventListener("focus", dispatchFocus, false);
      el.addEventListener("blur", dispatchBlur, false);
    }
    function removeFocus() {
      el.removeEventListener("focus", dispatchFocus, false);
      el.removeEventListener("blur", dispatchBlur, false);
    }
    h.remove = function () {
      if (!el) return;
      el.removeEventListener("mouseover", dispatchOver, false);
      el.removeEventListener("mouseout", dispatchOut, false);
      removeFocus();
    };
    if (el) {
      el.addEventListener("mouseover", dispatchOver, false);
      el.addEventListener("mouseout", dispatchOut, false);
    }
    return h;
  };
  return hoverintent$1;
}
var hoverintentExports = requireHoverintent();
const hoverintent = /* @__PURE__ */ getDefaultExportFromCjs(hoverintentExports);
class DetailsDisclosureBase extends HTMLElement {
  constructor(focusOut = true) {
    super();
    this.name = this.dataset.name ?? "disclosure";
    this.containerClasses = [`has-open-${this.name}`];
    this.focusOut = focusOut;
    this.onSummaryClick = this.handleSummaryClick.bind(this);
    this.onFocusOut = this.handleFocusOut.bind(this);
    this.onKeyUp = this.handleKeyup.bind(this);
    this.disclosureContainer = this.closest("[data-disclosure-container]");
    this.detailsElement = this.querySelector("details");
    this.summaryElement = this.querySelector("summary");
  }

  connectedCallback() {
    this.bindEvents();
  }

  disconnectedCallback() {
    this.unbindEvents();
  }

  bindEvents() {
    this.summaryElement.addEventListener("click", this.onSummaryClick);
    if (this.focusOut) {
      this.detailsElement.addEventListener("focusout", this.onFocusOut);
    }
    this.detailsElement.addEventListener("keyup", this.onKeyUp);
  }

  unbindEvents() {
    this.summaryElement.removeEventListener("click", this.onSummaryClick);
    if (this.focusOut) {
      this.detailsElement.removeEventListener("focusout", this.onFocusOut);
    }
    this.detailsElement.removeEventListener("keyup", this.onKeyUp);
  }

  isOpen() {
    return this.detailsElement.hasAttribute("open");
  }

  handleSummaryClick(event) {
    event.preventDefault();
    this.isOpen() ? this.close() : this.open();
  }

  handleFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  handleKeyup(event) {
    event.code.toUpperCase() === "ESCAPE" && this.close();
  }

  open() {
    this.detailsElement.setAttribute("open", true);
    this.disclosureContainer.classList.add(...this.containerClasses);
  }

  close() {
    this.detailsElement.removeAttribute("open");
    this.summaryElement.setAttribute("aria-expanded", false);
    this.disclosureContainer.classList.remove(...this.containerClasses);
  }
}
class HeaderMenu extends DetailsDisclosureBase {
  constructor() {
    super();
    this.item = this.closest("li");
    this.child = this.querySelector("summary + div");
    this.innerChild = this.child.firstElementChild;
    this.allChildren = Array.from(
      this.disclosureContainer.querySelectorAll("header-menu summary + div"),
    );
    this.megaMenulinks = this.child.querySelectorAll("a[data-megamenu-link]");
    this.megaMenuPromoLinks = this.child.querySelectorAll(
      "a[data-megamenu-promo-link]",
    );
    this.megaMenuPromoImages = this.child.querySelectorAll(
      "a[data-megamenu-promo-link] img",
    );
    this.background = this.disclosureContainer.querySelector(
      "[data-menu-background]",
    );
    this.siblings = Array.from(
      this.disclosureContainer.querySelectorAll("header-menu"),
    ).filter((sibling) => sibling !== this);
    console.log(this.siblings);
    this.header = document.querySelector(".section-header");
    this.headerWrapper = document.querySelector(".header-wrapper");
    this.rootLinks = this.disclosureContainer.querySelectorAll(
      ".header__menu-item.link, .header__icon",
    );
    this.timeline = gsap.timeline({ paused: true });
    this.openTimeline = gsap.timeline({ paused: true });
    this.switchTimeline = gsap.timeline({
      paused: true,
      onComplete: () =>
        this.disclosureContainer.classList.remove("is-switching"),
    });
    this.onMouseOver = this.handleMouseOver.bind(this);
    this.onClose = this.handleClose.bind(this);
    this.onRootLinkHover = this.handleRootLinkHover.bind(this);
    this.onResize = this.handleResize.bind(this);
    this.hoverIntentListeners = null;
    this.getHeaderHeight();
    this.buildTimelines();
  }

  bindEvents() {
    super.bindEvents();
    if (typeof hoverintent !== "undefined") {
      const main = hoverintent(this, this.onMouseOver, () => {});
      main.options({ interval: 50 });
      const rootLinks = [];
      this.rootLinks.forEach((link) => {
        const rootLinkListener = hoverintent(
          link,
          this.onRootLinkHover,
          () => {},
        );
        rootLinkListener.options({ interval: 50 });
        rootLinks.push(rootLinkListener);
      });
      this.hoverIntentListeners = { main, rootLinks };
    } else {
      this.addEventListener("mouseenter", this.onMouseOver);
      this.rootLinks.forEach((link) =>
        link.addEventListener("mouseenter", this.onRootLinkHover),
      );
    }
    this.header.addEventListener("mouseleave", this.onClose);
    this.isSwitching = false;
  }

  unbindEvents() {
    super.unbindEvents();
    if (this.hoverIntentListeners) {
      this.hoverIntentListeners.main.remove();
      this.hoverIntentListeners.rootLinks.forEach((listener) =>
        listener.remove(),
      );
      this.hoverIntentListeners = null;
    } else {
      this.removeEventListener("mouseenter", this.onMouseOver);
      this.rootLinks.forEach((link) =>
        link.removeEventListener("mouseenter", this.onRootLinkHover),
      );
    }
    this.header.removeEventListener("mouseleave", this.onClose);
  }

  handleSummaryClick(e) {
    const innerLink = e.currentTarget.querySelector("a");
    if (innerLink) return;
    e.preventDefault();
  }

  handleResize() {
    if (this.isOpen()) {
      this.updateHeight();
    }
  }

  getSubnavHeight() {
    return this.child.offsetHeight;
  }

  updateHeight() {
    gsap.set(this.background, {
      y: this.getSubnavHeight.bind(this),
    });
  }

  buildTimeline(timeline, switching) {
    timeline
      .to(this.background, {
        y: this.getSubnavHeight.bind(this),
        duration: switching ? 0.25 : 0.35,
        ease: "power2.inOut",
      })
      .to(
        this.allChildren,
        {
          opacity: 0,
          duration: 0.35,
          ease: "power2.out",
        },
        0,
      )
      .fromTo(
        this.child,
        {
          opacity: 0,
        },
        {
          opacity: 1,
          duration: 0.35,
          ease: switching ? "power2.in" : "power2.inOut",
        },
        switching ? 0 : 0.2,
      )
      .fromTo(
        this.megaMenuPromoLinks,
        {
          opacity: 0,
        },
        {
          opacity: 1,
          duration: 0.25,
          ease: "power2.inOut",
          stagger: 0.15,
        },
        0.35,
      )
      .fromTo(
        this.megaMenuPromoImages,
        {
          scale: 1.2,
        },
        {
          scale: 1,
          duration: 1.5,
          ease: "power2.inOut",
        },
        0,
      )
      .fromTo(
        this.megaMenulinks,
        {
          opacity: 0,
          y: -10,
        },
        {
          y: 0,
          opacity: 1,
          duration: 0.05,
          ease: "power2.inOut",
          stagger: switching ? 0 : 0.05,
        },
        switching ? 0 : 0.1,
      );
    if (!switching) {
      timeline.fromTo(
        this.innerChild,
        {
          y: -60,
        },
        {
          y: 0,
          duration: 0.5,
          ease: "power2.inOut",
          onComplete: () =>
            gsap.set(this.innerChild, { clearProps: "y" }),
        },
        0.05,
      );
    } else {
      gsap.set(this.innerChild, { clearProps: "y" });
    }
  }

  buildTimelines() {
    this.buildTimeline(this.openTimeline, false);
    this.buildTimeline(this.switchTimeline, true);
  }

  isOpen() {
    return this.item.classList.contains("is-open");
  }

  handleMouseOver() {
    this.open();
  }

  handleClose() {
    this.cancelClose();
    this.closingTime = setTimeout(() => {
      this.close();
    }, 150);
  }

  handleRootLinkHover() {
    if (this.isOpen()) {
      this.handleClose();
    }
  }

  getHeaderHeight() {
    if (
      document.documentElement.style.getPropertyValue(
        "--header-bottom-position-desktop",
      ) === ""
    ) {
      document.documentElement.style.setProperty(
        "--header-bottom-position-desktop",
        `${Math.floor(this.headerWrapper.getBoundingClientRect().bottom)}px`,
      );
    }
  }

  open() {
    this.isSwitching = this.hasOpenSibling();
    this.cancelClose();
    this.closeSiblings();
    if (this.isOpen()) return;
    super.open();
    if (this.isSwitching) {
      this.disclosureContainer.classList.add("is-switching");
    }
    this.item.classList.add("is-open");
    this.headerWrapper.preventHide = true;
    window.addEventListener("resize", this.onResize);
    setTimeout(() => {
      this.disclosureContainer.classList.add("has-menu-buffer");
      if (this.isSwitching) {
        this.switchTimeline.invalidate().play(0);
      } else {
        this.openTimeline.invalidate().play(0);
      }
    });
  }

  hasOpenSibling() {
    return this.siblings.some((sibling) => sibling.isOpen());
  }

  cancelClose() {
    clearTimeout(this.closingTime);
    this.closingTime = void 0;
  }

  closeSiblings() {
    this.siblings.forEach((sibling) => sibling.close());
  }

  close() {
    this.cancelClose();
    if (!this.isOpen()) return;
    this.headerWrapper.preventHide = false;
    this.item.classList.remove("is-open");
    this.summaryElement.setAttribute("aria-expanded", false);
    window.removeEventListener("resize", this.onResize);
    setTimeout(() => {
      gsap.to(this.megaMenulinks, {
        opacity: 0,
        duration: 0.1,
        ease: "power2.inOut",
      });
      gsap.to(this.megaMenuPromoLinks, {
        opacity: 0,
        duration: 0.1,
        ease: "power2.inOut",
      });
      if (!this.hasOpenSibling()) {
        this.disclosureContainer.classList.remove(...this.containerClasses);
        this.timeline.pause();
        gsap.to(this.innerChild, {
          duration: 0.5,
          y: -60,
          ease: "power2.inOut",
          onComplete: () =>
            gsap.set(this.innerChild, { clearProps: "y" }),
        });
        gsap.to(this.child, {
          opacity: 0,
          duration: 0.4,
          ease: "power2.inOut",
        });
        gsap.to(this.background, {
          y: 0,
          duration: 0.5,
          ease: "power2.inOut",
          delay: 0.05,
        });
      }
    });
    this.closeAnimation();
  }

  closeAnimation() {
    let animationStart;
    const handleAnimation = (time) => {
      if (animationStart === void 0) {
        animationStart = time;
      }
      const elapsedTime = time - animationStart;
      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else if (!this.isOpen()) {
        this.detailsElement.removeAttribute("open");
        if (!this.hasOpenSibling()) {
          this.disclosureContainer.classList.remove("has-menu-buffer");
        }
      }
    };
    window.requestAnimationFrame(handleAnimation);
  }
}
defineElement("header-menu", HeaderMenu);
const detailsDisclosure = /* @__PURE__ */ Object.freeze(
  /* @__PURE__ */ Object.defineProperty(
    {
      __proto__: null,
      DetailsDisclosureBase,
      HeaderMenu,
    },
    Symbol.toStringTag,
    { value: "Module" },
  ),
);
export { DetailsDisclosureBase, detailsDisclosure, hoverintent };
